export default __webpack_public_path__ + "static/media/5.fb63485b.jpg";